import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=27474991&"
import script from "./Expired.vue?vue&type=script&lang=js&"
export * from "./Expired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports